import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Container from "components/Container"
import BlockContent from "components/BlockContent"
import theme from "styles/theme"

const LegalBlock = ({ content }) => (
  <Container
    max={942}
    wrapperStyles={{
      padding: "85px 74px 90px",
      [theme.tablet]: { padding: "68px 74px" },
      [theme.mobile]: { padding: "50px 40px" },
    }}
  >
    <BlockContent
      css={{
        fontSize: 14,
        lineHeight: 1.4,
        color: theme.darkGray,
        [["ol", "ul"]]: {
          margin: "0 0 0 1.75em",
          paddingLeft: "1em",
          [theme.mobile]: { marginLeft: 10, marginRight: 0 },
        },
        li: { margin: "1em 0" },
        "a:hover": { color: theme.textGray },
        [theme.tablet]: { fontSize: 13 },
        [theme.mobile]: { fontSize: 12 },
      }}
    >
      {content}
    </BlockContent>
  </Container>
)

export default LegalBlock

LegalBlock.propTypes = {
  content: PropTypes.array.isRequired,
}

export const query = graphql`
  fragment LegalBlock on SanityLegalBlock {
    content: _rawContent
  }
`
